<template>
  <div style="background-color: #fff ;">
    <v-layout column justify-center align-center style="min-height: 100vh" >
      <v-flex xs12 sm8 md6>
        <div class="text-center my-1">
            <!-- <v-img width="400" src='/static/images/logo-solivera.png' /> -->
        </div>

        <div class="text-center my-1">
        
					<v-btn style="font-size: xx-large;" text :to="{ name: 'Index', params: { id: '1589756239' } }">S'Olivera</v-btn>	<br><br><br>
     	
					<v-btn style="font-size: xx-large;" text :to="{ name: 'Index', params: { id: '1591174997' } }">La Martina</v-btn>				
        </div>
				
				<v-footer absolute color="#C9E5F9">
					<v-col class="text-center" cols="12">
						by Uebs App Lab SL
					</v-col>
				</v-footer>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  components: {},
}
</script>
